/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The network surfaces through which a Speakeasy-hosted MCP server may be reached.
 */
export const CreateMetaMcpServerFormNetworkAccessMode = {
  PublicOnly: "public_only",
  Dual: "dual",
  PrivateOnly: "private_only",
} as const;
/**
 * The network surfaces through which a Speakeasy-hosted MCP server may be reached.
 */
export type CreateMetaMcpServerFormNetworkAccessMode = ClosedEnum<
  typeof CreateMetaMcpServerFormNetworkAccessMode
>;

/**
 * The visibility of a meta MCP server. Disabled refuses traffic; private requires a user session.
 */
export const CreateMetaMcpServerFormVisibility = {
  Disabled: "disabled",
  Private: "private",
} as const;
/**
 * The visibility of a meta MCP server. Disabled refuses traffic; private requires a user session.
 */
export type CreateMetaMcpServerFormVisibility = ClosedEnum<
  typeof CreateMetaMcpServerFormVisibility
>;

/**
 * Form for creating a new meta MCP server. URL addressability is managed separately through MCP endpoints.
 */
export type CreateMetaMcpServerForm = {
  /**
   * The display name of the meta MCP server
   */
  name: string;
  /**
   * The network surfaces through which a Speakeasy-hosted MCP server may be reached.
   */
  networkAccessMode?: CreateMetaMcpServerFormNetworkAccessMode | undefined;
  /**
   * The ID of the user session issuer used to authenticate callers. Omit for no issuer.
   */
  userSessionIssuerId?: string | undefined;
  /**
   * The visibility of a meta MCP server. Disabled refuses traffic; private requires a user session.
   */
  visibility?: CreateMetaMcpServerFormVisibility | undefined;
};

/** @internal */
export const CreateMetaMcpServerFormNetworkAccessMode$outboundSchema:
  z.ZodMiniEnum<typeof CreateMetaMcpServerFormNetworkAccessMode> = z.enum(
    CreateMetaMcpServerFormNetworkAccessMode,
  );

/** @internal */
export const CreateMetaMcpServerFormVisibility$outboundSchema: z.ZodMiniEnum<
  typeof CreateMetaMcpServerFormVisibility
> = z.enum(CreateMetaMcpServerFormVisibility);

/** @internal */
export type CreateMetaMcpServerForm$Outbound = {
  name: string;
  network_access_mode?: string | undefined;
  user_session_issuer_id?: string | undefined;
  visibility?: string | undefined;
};

/** @internal */
export const CreateMetaMcpServerForm$outboundSchema: z.ZodMiniType<
  CreateMetaMcpServerForm$Outbound,
  CreateMetaMcpServerForm
> = z.pipe(
  z.object({
    name: z.string(),
    networkAccessMode: z.optional(
      CreateMetaMcpServerFormNetworkAccessMode$outboundSchema,
    ),
    userSessionIssuerId: z.optional(z.string()),
    visibility: z.optional(CreateMetaMcpServerFormVisibility$outboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      networkAccessMode: "network_access_mode",
      userSessionIssuerId: "user_session_issuer_id",
    });
  }),
);

export function createMetaMcpServerFormToJSON(
  createMetaMcpServerForm: CreateMetaMcpServerForm,
): string {
  return JSON.stringify(
    CreateMetaMcpServerForm$outboundSchema.parse(createMetaMcpServerForm),
  );
}
